import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const PromoBanner = () => {
  const scrollToBooking = () => {
    const el = document.querySelector("#booking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="promo-banner" className="relative overflow-hidden">
      <div className="bg-brand-gold py-4 md:py-5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
          <div className="flex items-center gap-2">
            <Sparkles size={18} className="text-black" />
            <p className="font-serif text-lg md:text-xl font-semibold text-black text-center">
              Book Online in <span className="underline">60 Seconds</span>
            </p>
            <Sparkles size={18} className="text-black" />
          </div>
          <p className="font-sans text-xs md:text-sm text-black/70 text-center">
            Only a $25 deposit secures your appointment — it counts toward your total!
          </p>
          <button
            onClick={scrollToBooking}
            data-testid="promo-book-btn"
            className="bg-black text-brand-gold font-sans font-semibold text-xs px-5 py-2 hover:bg-black/80 transition-colors whitespace-nowrap"
          >
            Book & Save Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default PromoBanner;
